export default {
  dirty: false,
  touched: false,
};
